/* eslint-disable react/no-danger */
import React from "react"
import { preventWidow } from "utils/preventWidow"
import { formatDate, blogSlug } from "components/Blog/utils/Blog.utils"
import type { ReducedBlogV2AuthorType } from "types/blog-v2-types"
import { container, header, byLine, date } from "./PostHeader.css"

type Props = {
  title: string
  author: ReducedBlogV2AuthorType
  publishDate: Date
  locale: "en-GB" | "en-US"
}

export const PostHeader: React.FC<Props> = ({
  title,
  author,
  publishDate,
  locale,
}) => {
  const { slug, fullName } = author
  return (
    <div className={container}>
      <h1 className={header} dangerouslySetInnerHTML={preventWidow(title)} />
      <p className={byLine}>
        Written by{" "}
        <a
          href={`${locale === "en-US" ? "/us" : ""}${blogSlug}/author/${slug}`}
          title={`Read more posts by ${fullName}`}
        >
          {fullName}
        </a>
      </p>
      <p className={date}>{formatDate(publishDate)}</p>
    </div>
  )
}
